<template>
  <v-dialog
    :value="value"
    :fullscreen="fullscreen"
    :content-class="fillHeight && !fullscreen ? 'fill-height' : ''"
    persistent
    scrollable
    :width="width"
    @input="close"
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar
          color="primary"
          dark
          dense
          flat
        >
          <v-row align="center">
            <v-col cols="1">
              <v-btn icon @click="close">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="10" class="text-center">
              <v-toolbar-title v-text="title" />
            </v-col>
          </v-row>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-container>
          <slot />
        </v-container>
      </v-card-text>
      <v-footer v-if="hasFooter" padless>
        <v-toolbar dense>
          <slot name="footer" />
        </v-toolbar>
      </v-footer>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AgModalContainer',
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    fillHeight: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: 'auto',
    },
  },
  computed: {
    hasFooter () {
      return !!this.$slots.footer
    },
  },
  methods: {
    close () {
      this.$emit('input', false)
      this.$emit('close')
    },
  },
}
</script>
